export enum PEAAccountTypeEnumFR {
  PEA = 'PEA',
  PEA_PME = 'PEA_PME',
}

export enum PEAAccountTypeEnum {
  PEA = 'PEA',
  PEA_SMB = 'PEA_SMB',
}

export const translatePEAAccountType = (pat: PEAAccountTypeEnumFR): PEAAccountTypeEnum => {
  switch (pat) {
    case PEAAccountTypeEnumFR.PEA:
      return PEAAccountTypeEnum.PEA;
    case PEAAccountTypeEnumFR.PEA_PME:
      return PEAAccountTypeEnum.PEA_SMB;
  }
};
